import script from "./AppList.vue?vue&type=script&setup=true&lang=js"
export * from "./AppList.vue?vue&type=script&setup=true&lang=js"

import "./AppList.vue?vue&type=style&index=0&id=1dc8d362&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc8d362"]])

export default __exports__